/**
 * Endpoints the console sets over the issuer's discovery document: Cognito's logout URL (its discovery has none) and,
 * under dev:aws, the local sign-in page that fronts the emulator's plain login form (scripts/login-page.mjs).
 */
export interface AuthEndpoints {
  endSessionUrl?: string | undefined;
  authorizeUrl?: string | undefined;
}

/** The `metadataSeed` for oidc-client-ts, or undefined when nothing overrides discovery. */
export function metadataSeedOf({ endSessionUrl, authorizeUrl }: AuthEndpoints): { end_session_endpoint?: string; authorization_endpoint?: string } | undefined {
  const seed = { ...(endSessionUrl ? { end_session_endpoint: endSessionUrl } : {}), ...(authorizeUrl ? { authorization_endpoint: authorizeUrl } : {}) };
  return Object.keys(seed).length ? seed : undefined;
}
